import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'

import BACKGROUND from '_images/backgrounds/bgr.jpg'

import styles from './styles.css'
import CategoryTabIcon from './categoryTabIcon'

const CATEGORIES = {
  tasks: {
    name: 'tasks',
    color: '#4E9D82',
  },
  thoughts: {
    name: 'thoughts',
    color: '#9AD98E',
  },
  emotions: {
    name: 'emotions',
    color: '#F46063',
  },
  engagement: {
    name: 'engagement',
    color: '#F0A366',
  },
}

class CategoryTabs extends Component {
  static propTypes = {
    closePlusForm: PropTypes.func,
  }

  static defaultProps = {
    closePlusForm: () => {},
  }

  state = {
    selectedTab: 'tasks',
  }

  changeTab = type => {
    this.setState({ selectedTab: type })
  }

  render() {
    const { closePlusForm, children } = this.props
    const { selectedTab } = this.state
    const keys = Object.keys(CATEGORIES)
    const selectionIndex = keys.indexOf(selectedTab)
    const selectionColor = CATEGORIES[keys[selectionIndex]].color
    const borderLeft = `${selectionIndex * 25}%`

    return (
      <div
        style={{
          backgroundImage: `url(${BACKGROUND})`,
          backgroundSize: 'cover',
          borderRadius: 10,
          padding: '20px 0 20px 0',
          flex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ display: 'flex', flex: 0.16 }}>
          {keys.map(k => {
            const { name, color } = CATEGORIES[k]
            return (
              <CategoryTabIcon
                key={name}
                type={name}
                color={color}
                selectedTab={selectedTab}
                onClick={this.changeTab}
              />
            )
          })}
        </div>
        <div
          style={{ flex: 0.01, background: 'rgba(255,255,255,0.2)', borderRadius: 5, height: 5 }}
        >
          <div
            className={styles.selectedBorder}
            style={{
              position: 'absolute',
              left: borderLeft,
              width: '25%',
              border: `3px solid ${selectionColor}`,
              borderRadius: 5,
            }}
          />
        </div>
        <div style={{ flex: 0.83, display: 'flex' }}>
          {selectedTab === 'tasks' &&
            !!children &&
            !!children[0] &&
            React.cloneElement(children[0], { closePlusForm })}
          {selectedTab === 'thoughts' &&
            !!children &&
            !!children[1] &&
            React.cloneElement(children[1], { closePlusForm })}
          {selectedTab === 'emotions' &&
            !!children &&
            !!children[2] &&
            React.cloneElement(children[2], { closePlusForm })}
          {selectedTab === 'engagement' &&
            !!children &&
            !!children[3] &&
            React.cloneElement(children[3], { closePlusForm })}
        </div>
      </div>
    )
  }
}

export default CategoryTabs



// WEBPACK FOOTER //
// ./src/components/categoryTabs/index.js